export default [
    {
        icon: 'GridIcon',
        route: 'patient-info',
        title: 'Patienten Info'
    },
]
